import { api } from '@/shared/api/client';

export const fetchAirportCounters = async (hotelId?: string) => {
    return api.get('/airports/counters', {
        query: hotelId ? { hotel_id: hotelId } : undefined,
    });
};

export const confirmAirportClosing = async (counterId: string) => {
    return api.get('/airports/counters/{airport_reception_id}/closing/confirmation', {
        path: { airport_reception_id: counterId },
    });
};

export const createAirportClosing = async (counterId: string) => {
    return api.post('/airports/counters/{airport_reception_id}/closing', {
        path: { airport_reception_id: counterId },
    });
};

export const deleteAirportClosing = async (counterId: string) => {
    return api.delete('/airports/counters/{airport_reception_id}/closing', {
        path: { airport_reception_id: counterId },
    });
};
